// ============================================================================
// OrgTreeNode — rendu recursif d'un noeud de l'arbre (E1c, F-238)
// ============================================================================
// Portage verbatim du PoC (components/org/org-tree-node.tsx). Les connecteurs
// (lignes) viennent du ruleset `.org-tree` de src/index.css ; ici on ne pose que
// la structure ul/li. Un groupe etiquete (equipe != equipe du parent) s'insere
// comme un <li> intermediaire : boite d'etiquette d'equipe puis sous-rangee
// d'enfants — l'equivalent des boites rouges de l'organigramme de reference.
// Le groupement lui-meme est calcule par buildOrgForest (DEJA porte) : ce
// composant ne fait que le rendre.

import type { OrgChildGroup, OrgNode } from '../../lib/org/hierarchy';
import { OrgNodeCard } from './OrgNodeCard';

export function OrgTreeNode({
  node,
  depth,
  collapsed,
  highlightedEmail,
  onToggle,
}: {
  node: OrgNode;
  depth: number;
  collapsed: ReadonlySet<string>;
  highlightedEmail?: string | null;
  onToggle: (email: string) => void;
}) {
  const isCollapsed = collapsed.has(node.email);

  return (
    <li>
      <OrgNodeCard
        node={node}
        depth={depth}
        isCollapsed={isCollapsed}
        isHighlighted={highlightedEmail === node.email}
        onToggle={() => onToggle(node.email)}
      />
      {node.children.length > 0 && !isCollapsed ? (
        <ul>
          {node.children.map((group) =>
            group.team_label === null ? (
              group.children.map((child) => (
                <OrgTreeNode
                  key={child.email}
                  node={child}
                  depth={depth + 1}
                  collapsed={collapsed}
                  highlightedEmail={highlightedEmail}
                  onToggle={onToggle}
                />
              ))
            ) : (
              <TeamGroup
                key={group.team_id ?? group.team_label}
                group={group}
                depth={depth}
                collapsed={collapsed}
                highlightedEmail={highlightedEmail}
                onToggle={onToggle}
              />
            ),
          )}
        </ul>
      ) : null}
    </li>
  );
}

/** Boite d'etiquette d'equipe + sous-rangee (enfants rattaches a une AUTRE equipe). */
function TeamGroup({
  group,
  depth,
  collapsed,
  highlightedEmail,
  onToggle,
}: {
  group: OrgChildGroup;
  depth: number;
  collapsed: ReadonlySet<string>;
  highlightedEmail?: string | null;
  onToggle: (email: string) => void;
}) {
  return (
    <li>
      <span className="whitespace-nowrap rounded-md border border-brand-200 bg-brand-50 px-2.5 py-1 text-chip font-medium text-brand-700 dark:border-brand-900 dark:bg-brand-950/40 dark:text-brand-300">
        {group.team_label}
      </span>
      <ul>
        {group.children.map((child) => (
          <OrgTreeNode
            key={child.email}
            node={child}
            depth={depth + 1}
            collapsed={collapsed}
            highlightedEmail={highlightedEmail}
            onToggle={onToggle}
          />
        ))}
      </ul>
    </li>
  );
}
